import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const { innerWidth: screenWidth, innerHeight: screenHeight } = window;
    return {
      screenWidth,
      screenHeight,
      isMobile: screenWidth < 480,
      isTab: screenWidth < 1000,
    };
}


export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}